import React from 'react';
import PropTypes from 'prop-types';

import FilterSelector from 'components/search_sidebar/filter_selector';
import { Form } from 'react-bootstrap-5';

export default class TagsFilter extends React.Component {

  static propTypes = {
    availableTags: PropTypes.array.isRequired,
    canManageTags: PropTypes.bool,
    excludeTags: PropTypes.bool.isRequired,
    selectedTags: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onSelectAllChange: PropTypes.func.isRequired,
    onSelectExcludeTags: PropTypes.func.isRequired,
    onSelectManageTags: PropTypes.func
  };

  static defaultProps = {
    canManageTags: false,
  }

  state = {
    searchText: '',
    selectAllState: false
  };

  isChecked = (value) => {
    return this.props.selectedTags.indexOf(value) >= 0;
  }

  handleSelect = (e) => {
    const { onAdd } = this.props;
    const tag = e.target.value;
    this.isChecked(tag) ? this.handleOnRemove(tag) : onAdd(tag);
  }

  handleOnRemove = (tag) => {
    const { onRemove } = this.props;
    const { selectAllState } = this.state;

    if (selectAllState) {
      this.setState({
        selectAllState: false
      });
    }

    onRemove(tag);
  }

  handleExclude = (tag) => {
    const { onAdd, onRemove } = this.props;
    this.isChecked(tag) ? onRemove(tag) : onAdd(tag);
  }

  handleSearchChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
  }

  manageSelectAll = () => {
    const { onSelectAllChange, availableTags, onAdd } = this.props;
    const { selectAllState } = this.state;
    const selectAllValue = !selectAllState;


    this.setState({
      selectAllState: selectAllValue
    });

    if (selectAllValue) {
      availableTags.forEach((tag) => {
        this.isChecked(tag) ? '' : onAdd(tag);
      });
    } else {
      onSelectAllChange();
    }
  }

  manageExcludeTags = (e) => {
    const value = e.target.value;
    const { excludeTagsState } = this.state;
    const excludeTagsValue = excludeTagsState.includes(value) ? [] : [value];

    this.setState({
      excludeTagsState: excludeTagsValue
    });
  }

  renderTagOptions = () => {
    const { searchText } = this.state;
    const { availableTags } = this.props;

    return availableTags.map((tag) => {
      if (tag.toLowerCase().includes(searchText.toLowerCase())) {
        return (
          <div className="filter-checkbox" key={tag}>
            <Form.Check
              checked={this.isChecked(tag)}
              inline
              label={tag}
              type="checkbox"
              value={tag}
              onChange={this.handleSelect}
            />
          </div>
        );
      }
    }).filter(Boolean);
  }

  render() {
    const { canManageTags, excludeTags, onSelectExcludeTags, onSelectManageTags } = this.props;
    const { searchText, selectAllState } = this.state;

    const tagOptions = this.renderTagOptions();

    return (
      <>
        <FilterSelector
          searchText={searchText}
          searchTextPlaceHolder="Search tags"
          onSearchChange={this.handleSearchChange}
        >
          <div className="p-3 border rounded mt-3 overflow-y-auto" style={{ maxHeight: '200px' }}>
            <div className="pb-2 mb-2 border-bottom">
              <Form.Check
                checked={selectAllState}
                inline
                label="Select All"
                type="checkbox"
                value={'select_all'}
                onChange={this.manageSelectAll}
              />
            </div>
            {tagOptions.length > 0 ? tagOptions : <span className="text-muted">No matching tags found</span>}

            <Form.Check
              checked={excludeTags}
              label="(No Tag)"
              type="checkbox"
              value={'exclude_tags'}
              onChange={onSelectExcludeTags}
            />
          </div>
        </FilterSelector>
        {canManageTags &&
          <a href="javascript:void(0)" onClick={onSelectManageTags}>
            Manage Tags
          </a>
        }
      </>
    );
  }
}
